/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Polygon } from "./Polygon";
import {
  PolygonFromJSON,
  PolygonFromJSONTyped,
  PolygonToJSON,
  PolygonToJSONTyped,
} from "./Polygon";

/**
 *
 * @export
 * @interface ForcingSubstanceWithZone
 */
export interface ForcingSubstanceWithZone {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  substance: string;
  /**
   *
   */
  readonly substanceId?: number;
  /**
   *
   */
  readonly substanceName?: string;
  /**
   * Timeseries provided as a nested list. The inner list consists of exactly 2 values: timestamp, value
   */
  concentrations: Array<Array<number>>;
  /**
   *
   */
  zone?: Polygon;
}

/**
 * Check if a given object implements the ForcingSubstanceWithZone interface.
 */
export function instanceOfForcingSubstanceWithZone(
  value: object
): value is ForcingSubstanceWithZone {
  if (!("substance" in value) || value["substance"] === undefined) return false;
  if (!("concentrations" in value) || value["concentrations"] === undefined) return false;
  return true;
}

export function ForcingSubstanceWithZoneFromJSON(json: any): ForcingSubstanceWithZone {
  return ForcingSubstanceWithZoneFromJSONTyped(json, false);
}

export function ForcingSubstanceWithZoneFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ForcingSubstanceWithZone {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    substance: json["substance"],
    substanceId: json["substance_id"] == null ? undefined : json["substance_id"],
    substanceName: json["substance_name"] == null ? undefined : json["substance_name"],
    concentrations: json["concentrations"],
    zone: json["zone"] == null ? undefined : PolygonFromJSON(json["zone"]),
  };
}

export function ForcingSubstanceWithZoneToJSON(json: any): ForcingSubstanceWithZone {
  return ForcingSubstanceWithZoneToJSONTyped(json, false);
}

export function ForcingSubstanceWithZoneToJSONTyped(
  value?: Omit<ForcingSubstanceWithZone, "id" | "substanceId" | "substanceName"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    substance: value["substance"],
    concentrations: value["concentrations"],
    zone: PolygonToJSON(value["zone"]),
  };
}
